<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-class="redmfu">
            <div slot="header">
              <strong v-if="thai_student==1">แจ้งความจำนงเข้ารับพระราชทานปริญญาบัตร</strong>
              <strong v-else>Confirmation of intention to attend (or not attend) the MFU Commencement Ceremony</strong>
              <div style="float:right;"
              >
                <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                  {{ this.$store.state.timeExp }}
                </b-badge>
              </div>
            </div>
            <b-card>
              <div slot="header">
                <strong v-if="thai_student==1">แจ้งความจำนงเข้ารับพระราชทานปริญญาบัตร</strong>
                <strong v-else>Confirmation of intention to attend (or not attend) the MFU Commencement Ceremony</strong>
              </div>
            <b-form-radio-group

              v-if="thai_student==1 "
              v-model="selected_first"
              value-field="BYTECODE"
              text-field="BYTEDES"
              :options="items_first_thai"
              @change="onChangeFirst"
            ></b-form-radio-group>
            <b-form-radio-group
              v-if="thai_student==0 "
              v-model="selected_first"
              value-field="BYTECODE"
              text-field="BYTEDES"
              :options="items_first_eng"
              @change="onChangeFirst"
            ></b-form-radio-group>
            <b-form-group label-cols-sm="1" label label-align-sm="right" label-for="nested-street">
              <b-form-radio-group
                v-model="selected_regis"
                value-field="BYTECODE"
                text-field="BYTEDES"
                :options="items"
                stacked
                name="selected_regis"
              >
                <div
                  v-if="selected_regis=='20' ||selected_regis=='22' || selected_regis=='23' || selected_regis=='24' || selected_regis=='50' || selected_regis=='60'  || selected_regis=='70' || selected_regis=='80' "
                >
                  <br>
                  <b-form-group v-if="thai_student ==1" label="ระบุเหตุผล" label-for="basicStatic" :label-cols="2">

                    <b-form-textarea
                      id="other_txt"
                      v-model="other_txt"
                      :state="validation_other"
                      placeholder="Enter something..."
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>

                    <b-form-invalid-feedback :state="validation_other">
                      Please give the reason must be 10-300 characters long.
                    </b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation_other">
                      Correct.
                    </b-form-valid-feedback>
                  </b-form-group>

                  <b-form-group v-if="thai_student ==0" label="Please give the reason" label-for="basicStatic"
                                :label-cols="2">
                    <b-form-textarea
                      id="other_txt"
                      v-model="other_txt"
                      :state="validation_other"
                      placeholder="Enter something..."
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>

                    <b-form-invalid-feedback :state="validation_other">
                      Please give the reason must be 10-300 characters long.
                    </b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation_other">
                      Correct.
                    </b-form-valid-feedback>
                  </b-form-group>


                </div>
              </b-form-radio-group>
              <div v-if="selected_regis=='21'">
                <label
                  class="mr-sm-2"
                  v-if="thai_student==1"
                ><strong><font color="red">กรุณาระบุอายุครรภ์ให้ระบุถึง ณ เดือนกุมภาพันธ์ 2568</font></strong></label>
                <label
                  class="mr-sm-2"
                  v-if="thai_student==0"
                ><strong><font color="red">Please specify the gestational age until February 2025 </font></strong></label>
              </div>

              <b-form-select
                v-if="selected_regis=='21' && thai_student==1 && selected_first==1"
                v-model="selected_month"
                class="mb-2 mr-sm-2 mb-sm-0"
              >
                <option :value="0">เลือกจำนวนเดือน</option>
                <option value="2">2 เดือน</option>
                <option value="3">3 เดือน</option>
                <option value="4">4 เดือน</option>
                <option value="5">5 เดือน</option>
                <option value="6">6 เดือน</option>
                <option value="7">7 เดือน</option>
                <option value="8">8 เดือน</option>
                <option value="9">9 เดือน</option>
                <option value="10">10 เดือน</option>
              </b-form-select>
              <b-form-select
                v-model="selected_month"
                class="mb-3"
                v-if="selected_regis=='21' && thai_student==0 && selected_first==1"
              >
                <option :value="0">Select</option>
                <option value="2">2 Month</option>
                <option value="3">3 Month</option>
                <option value="4">4 Month</option>
                <option value="5">5 Month</option>
                <option value="6">6 Month</option>
                <option value="7">7 Month</option>
                <option value="8">8 Month</option>
                <option value="9">9 Month</option>
                <option value="10">10 Month</option>
              </b-form-select>
              <!--               select: {{ selected_regis }} {{ selected_month }}-->
            </b-form-group>
            </b-card>
            <b-card v-if="selected_first==1">
              <div slot="header">
                <strong v-if="thai_student==1">อาหารกลางวัน (วันฝึกซ้อมใหญ่: 17 มีนาคม 2568)</strong>
                <strong v-else>Lunch box (Final rehearsal day, March 17, 2025)</strong>
              </div>
            <b-row>

            </b-row>
              <b-row>
                <b-col lg="1"></b-col>
                <b-col lg="11">
                <b-form-radio-group
                  v-if="thai_student==1 "
                  v-model="selected_food"
                  value-field="ID"
                  text-field="FOODNAME"
                  :options="items_food_thai"
                  stacked
                ></b-form-radio-group>
                  <b-form-radio-group
                    v-else
                    v-model="selected_food"
                    value-field="ID"
                    text-field="FOODNAME"
                    :options="items_food_eng"
                    stacked
                  ></b-form-radio-group>
                </b-col>
              </b-row>

          </b-card>

            <div slot="footer" class="text-center">
              <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                <i class="fa fa-dot-circle-o"></i> Submit
              </b-button>

              <b-button type="reset" size="md" class="mr-2" variant="danger" @click="onReset">
                <i class="fa fa-ban"></i> Reset
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>


      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>
    <b-modal
      v-if="thai_student==1"
      title="คุณกรอกข้อมูลไม่ครบถ้วน"
      class="modal-danger"
      v-model="dangerModal"
      @ok="dangerModal = false"
      ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
    <b-modal
      v-if="thai_student==0"
      title="You didn’t fill your information completely"
      class="modal-danger"
      v-model="dangerModal"
      @ok="dangerModal = false"
      ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
import axios from 'axios';

export default {
  components: {YimoVueEditor},
  name: "CreateRegis",
  data() {
    return {
      options_vaccine_no:
        [
          {text: 'ได้รับวัคซีนตามประกาศของมหาวิทยาลัย', value: '1'},
        ],
      options_vaccine_no_eng: [
        {text: 'Having been vaccinated according to the University’s Notificaton', value: '1'},
      ],
      options_vaccine: [
        {text: 'ได้รับวัคซีนตามประกาศของมหาวิทยาลัย  ', value: '1'},
        {text: 'ยินยอมให้ตรวจ ATK 2 ครั้ง ', value: '2'}
      ],
      options_vaccine_eng: [
        {text: 'Having been vaccinated according to the University’s Notificaton', value: '1'},
        {text: 'I agree to do ATK testing two times ', value: '2'}
      ],
      items_first_eng: [
        {
          BYTECODE: "1",
          BYTEDES: "I will attend the Commencement Ceremony"
        }, {
          BYTECODE: "2",
          BYTEDES: "I will not attend the Commencement Ceremony"
        }], items_first_thai: [
        {
          BYTECODE: "1",
          BYTEDES: "เข้ารับพระราชทานปริญญาบัตร"
        }, {
          BYTECODE: "2",
          BYTEDES: "ไม่เข้ารับพระราชทานปริญญาบัตร"
        }
      ],
      items_food_thai:[
        {ID: "1", FOODNAME: "ทั่วไป"},{ID: "2", FOODNAME: "ฮาลาล"},{ID: "3", FOODNAME: "มังสวิรัติ และเจ"}
      ],
      items_food_eng:[
        {ID: "1", FOODNAME: "General"},{ID: "2", FOODNAME: "Halal"},{ID: "3", FOODNAME: "Vegetarian"}
      ],
      student: {},
      std_id: "",
      sex: "",
      studentCode: "",
      thai_student: "",
      prefixName: "",
      studentName: "",
      studentSurname: "",
      studentNameEng: "",
      studentSurnameEng: "",
      prefixNameEng: "",
      levelGroupNameEng: "",
      facultyName: "",
      facultyNameEng: "",
      departmentName: "",
      departmentNameEng: "",
      numEror: 0,
      current_erorrtxt: "",
      selected_regis: "",
      selected_vaccine: "",
      other_txt: "",
      selected_month: 0,
      dangerModal: false,
      items: [],
      actionUpdate: 10,
      levelid: "",
      file: "",
      Images:"",
      selected_first: "",
      selected_food: "",
      current_graduatestatus: "",
      current_postpone: "",
      q1: 0,
      q7: 0,
      q_total: 10,
    };
  },
  // watch: {
  //   test: function() {
  //     console.log("t1 ", test);
  //   }
  // },
  computed: {


    validation_other() {
      var spacestring = " ";
      var substring = "--";
      var string55 = "55";
      var string3 = "III";
      // console.log("length==", this.other_txt.length)
      if (this.other_txt == '') {
        return false;
      } else {
        // console.log("other_txt==",this.other_txt)
       if ((this.other_txt != null) && (this.other_txt != '')) {
          if ((this.other_txt == '-') || (this.other_txt == string55) || (this.other_txt == string3)) {
            return false;
          }
          if (this.other_txt.length <= 9) {
            return false;
          }
          // if (this.current_spell_name.includes(substring)) {
          if (this.other_txt.length >= 10 && this.other_txt.length < 300) {
            if (this.other_txt.includes(string55)) {
              return false;
            }
            if (this.other_txt.includes(string3)) {
              return false;
            }
            if (this.other_txt.includes(substring)) {
              return false;
            }
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
    },
  },
  methods: {
    onChangeFirst(checked) {
      // console.log( "ccc==",checked)
      this.q_total=this.q1+this.q7;
      // console.log("checked==",checked)
      // console.log("current_graduatestatus==", this.current_graduatestatus)
    /*  if (this.current_graduatestatus == 70) { //เลื่อน
        this.selected_first = checked;
        var start1, finish1;
        if (checked == 1) {
          start1 = 10;
          finish1 = 40;
        } else if (checked == 2) {
          start1 = 50;
          finish1 = 60;
        }
        this.getRegisType(this.thai_student, start1, finish1);
      } else { */

        if (this.q_total != 2) {
          if (this.current_postpone == 1) {
            this.selected_first = checked;
            var start1, finish1;
            if (checked == 1) {
              start1 = 10;
              finish1 = 40;
            } else if (checked == 2) {
              start1 = 50;
              finish1 = 60;
            }
            this.getRegisType(this.thai_student, start1, finish1);

          } else {
            this.numEror = this.numEror + 1;
            if (this.thai_student == 1) {
              this.current_erorrtxt =
                "ค้างตอบแบบสอบถามอื่นๆ กรุณากลับไปที่ เมนูหน้าหลัก";
            } else {
              this.current_erorrtxt =
                "Back to main page";
            }
            this.dangerModal = true;
          }
        } else if (this.q_total == 2) {
          // console.log("q_total==2")
          this.selected_first = checked;
          var start1, finish1;
          if (checked == 1) {
            start1 = 10;
            finish1 = 40;
          } else if (checked == 2) {
            start1 = 50;
            finish1 = 60;
          }
          this.getRegisType(this.thai_student, start1, finish1);
        } else {

        }
      //}
    },
    getCurrentStudent(studentid) {
      api
        .getStudentUserQuestionById(studentid)
        .then(res => {
          // console.log("res==", res);
          var currentSt = res.data.data[0];
          if (res.data.data.length == 1) {
            this.actionUpdate = 1;
            // console.log("res=", res);
            // console.log(" getCurrentStudent มีข้อมูล", this.actionUpdate);
            this.std_id = this.student.STUDENTID;
            this.selected_regis = currentSt.GRADUATE_STATUS;
            this.selected_food=currentSt.FOOD_ID;
            this.q1 = currentSt.QUESTIONNAIRE_1;
            // this.q7 = currentSt.QUESTIONNAIRE_7;
            // console.log("468==q7==", this.q7);
            this.q_total = this.q1 + this.q7;
            // console.log(this.q1,"+",this.q7,"==",this.q1+this.q7);
            // console.log("q1res=", this.q1);
            // console.log("q4res=", this.q4);

            if (currentSt.GRADUATE_STATUS == 21) {
              this.selected_month = currentSt.OTHER;
            } else if (
              currentSt.GRADUATE_STATUS == 20 ||
              currentSt.GRADUATE_STATUS == 22 ||
              currentSt.GRADUATE_STATUS == 23 ||
              currentSt.GRADUATE_STATUS == 24 ||
              currentSt.GRADUATE_STATUS == 50 ||
              currentSt.GRADUATE_STATUS == 60 ||
              currentSt.GRADUATE_STATUS == 70
            ) {
              this.other_txt = currentSt.OTHER;
            } else {
              this.other_txt = "";
            }
          } else {
            this.actionUpdate = 0;
            // console.log(" getCurrentStudent ไม่มีข้อมูล", this.actionUpdate);
          }

          return this.actionUpdate;
        })
        .catch(err => {
          console.log("getCurrentStudent", err.toString());
          this.actionUpdate = 10;
          this.$router.push("logout");
        });
    },

    setStudent: function () {
      var student = {};
      student.std_id = this.$store.state.user.studentid;
      student.qn_year = this.$store.state.user.year;
      student.selected_regis = this.selected_regis;

      if (this.selected_regis == 21) {
        student.other_txt = this.selected_month;
        student.selected_month = "";
      } else if (
        this.selected_regis == 20 ||
        this.selected_regis == 22 ||
        this.selected_regis == 23 ||
        this.selected_regis == 24 ||
        this.selected_regis == 50 ||
        this.selected_regis == 60 ||
        this.selected_regis == 70
      ) {
        student.other_txt = this.other_txt;
      } else {
        student.other_txt = "";
        student.selected_month = "";
      }
      if (
        this.selected_regis == 10 ||
        this.selected_regis == 21 ||
        this.selected_regis == 22 ||
        this.selected_regis == 23 ||
        this.selected_regis == 30 ||
        this.selected_regis == 40

      ) {
        student.food_id =this.selected_food;
      }else{
        student.food_id ='';
      }


      // console.log("setStudent==", student);
      return student;
    },

    getErrorTxt: function (s) {
      this.current_erorrtxt = "";
      var substring = "--";
      var dashstring="——";
      var substring55 = "55";
      var substring3 = "III";
      var quotation1 = "'";
      var quotation2 = "`";
      var substring2="——";
      var substring3="__";
      var substring4="- -";
      var starstring="**";
      var pointstring='..';
      this.numEror = 0;
      // console.log("s==",s)

      // console.log("selected_regis==",this.selected_regis)
      if ((this.selected_first == "") || (this.selected_regis == 0)) {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/เลือก "
            : this.current_erorrtxt + "/Please select";
      }
      if (
        (this.selected_regis == 20 ||
          this.selected_regis == 22 ||
          this.selected_regis == 23 ||
          this.selected_regis == 24 ||
          this.selected_regis == 50 ||
          this.selected_regis == 60 ||
          this.selected_regis == 70) &&

        ((this.other_txt == "") || (this.other_txt == "None") || (this.other_txt == undefined) || (this.other_txt == null))
      ) {

        this.numEror = this.numEror + 1;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/ระบุเหตุผล "
            : this.current_erorrtxt + "/Please give the reason";
      } else if (
        (this.selected_regis == 20 ||
          this.selected_regis == 22 ||
          this.selected_regis == 23 ||
          this.selected_regis == 24 ||
          this.selected_regis == 50 ||
          this.selected_regis == 60 ||
          this.selected_regis == 70) &&
        ((this.other_txt != "") && (this.other_txt != "None") && (this.other_txt != undefined) && (this.other_txt != null))
      ) {
        if (this.other_txt != "") {

          if (s.other_txt.toString().length > 0) {
            if (s.other_txt.includes(quotation1)) {
              s.other_txt = s.other_txt.replaceAll(quotation1, "''");
            }
            if (s.other_txt.includes(quotation2)) {
              s.other_txt = s.other_txt.replaceAll(quotation2, "''");
            }
          }
          if (this.other_txt.toString().length < 10 && this.other_txt.toString().length > 300) {
            this.numEror = this.numEror + 1;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ระบุเหตุผล" : this.current_erorrtxt + "/Please give the reason";
          } else {
            if (this.other_txt.toString().length > 0) {
              if (this.other_txt.includes(substring) || this.other_txt.includes(substring2)
                || this.other_txt.includes(substring3) || this.other_txt.includes(substring4)
                || this.other_txt.includes(substring4) || this.other_txt.includes(starstring)
                || this.other_txt.includes(pointstring)) {
                this.numEror = this.numEror + 1;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ระบุเหตุผล" : this.current_erorrtxt + "/Please give the reason";
              }
              if (this.other_txt.includes(dashstring)) {
                this.numEror = this.numEror + 1;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ระบุเหตุผล" : this.current_erorrtxt + "/Please give the reason";
              }
              if (this.other_txt.includes(substring55)) {
                this.numEror = this.numEror + 1;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ระบุเหตุผล" : this.current_erorrtxt + "/Please give the reason";
              }
              if (this.other_txt.includes(substring3)) {
                this.numEror = this.numEror + 1;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ระบุเหตุผล" : this.current_erorrtxt + "/Please give the reas";
              }
              if (this.other_txt == "-") {
                this.numEror = this.numEror + 1;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ระบุเหตุผล" : this.current_erorrtxt + "/Please give the reason";
              }
              if (this.other_txt == "5") {
                this.numEror = this.numEror + 1;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ระบุเหตุผล -" : this.current_erorrtxt + "/Please give the reason -";
              }
            }
          }
        }
      }
      if (
        this.selected_regis == 10 ||
        this.selected_regis == 21 ||
        this.selected_regis == 22 ||
        this.selected_regis == 23 ||
        this.selected_regis == 30 ||
        this.selected_regis == 40

      ) {
        if (this.selected_food==null || this.selected_food==0 || this.selected_food==""|| this.selected_food=='' ||  this.selected_food==undefined){
          this.numEror = this.numEror + 1;
          this.current_erorrtxt =
            this.thai_student == "1"
              ? this.current_erorrtxt + "/อาหารกลางวัน (วันฝึกซ้อมใหญ่: 17 มีนาคม 2568) "
              : this.current_erorrtxt + "/Lunch box (Final rehearsal day, March 17, 2025)";
        }
      }

      if (this.selected_regis == 21 && this.selected_month == 0) {
        this.numEror = this.numEror + 1;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/เลือกจำนวนเดือน "
            : this.current_erorrtxt + "/Select month";
      }
      if (this.current_graduatestatus == 70) {

      } else {
        if (this.current_postpone == 0) {
          if (this.q1 + this.q7 != 2) {
            this.numEror = this.numEror + 1;
            this.current_erorrtxt =
              this.thai_student == "1"
                ? this.current_erorrtxt + "/ค้างตอบแบบสอบถามอื่นๆ กรุณากลับไปที่ เมนูหน้าหลัก "
                : this.current_erorrtxt + "/Back to Home Menu";
          } else {
            if (this.q1 != 1) {
              this.numEror = this.numEror + 1;
              this.current_erorrtxt =
                this.thai_student == "1"
                  ? this.current_erorrtxt + "/ค้างตอบแบบสอบถามอื่นๆ กรุณากลับไปที่ เมนูหน้าหลัก "
                  : this.current_erorrtxt + "/Back to Home Menu";
            }
          }
        }
      }


      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
      s.num_error=this.numEror ;
      return s
    },
    onReset() {
      // console.log("Reset");
      this.selected_regis = "";
    },
    onSubmit() {

      var student = this.setStudent();
      var s = this.getErrorTxt(student);
      if (s.num_error == 0) {
        if (this.actionUpdate == 0) {
          // save
          this.$router.push("general");
        } else {
          // update
          this.onUpdateData(s);
        }
      }
    },
    nextPart() {
      if (
        this.selected_regis == 10 ||
        this.selected_regis == 20 ||
        this.selected_regis == 21 ||
        this.selected_regis == 22 ||
        this.selected_regis == 23 ||
        this.selected_regis == 24 ||
        this.selected_regis == 30 ||
        this.selected_regis == 40
      ) {
        this.$router.push("/confirm");
      } /*else if ((this.selected_regis==10) || (this.selected_regis==21) || (this.selected_regis==22)|| (this.selected_regis==23)
       || (this.selected_regis==24) || (this.selected_regis==30) || (this.selected_regis==40) ){
         //this.$router.push("/Dashboard"); //พริ้นใบรายงาน
         this.$router.push("/Dashboard");

       } */ else if (
        this.selected_regis == 50 ||
        this.selected_regis == 60

      ) {
        this.$router.push("/post"); //เลือกส่งไปรณีย์หรือมารับด้วยต้นเอง
      } else if (this.selected_regis == 70) {
        this.$router.push("/regisdetail");

      }
    },
    onUpdateData(student) {
      api
        .updateStudentRegis(student)
        .then(res => {
          // console.log(res);
          this.message = res.message;
          // console.log("update ผ่าน", this.studentId);
          if (res.data.code == 200) {
            this.nextPart();
          } else {

          }
        })
        .catch(err => {
          console.log(2);
          console.log("onUpdateData error", err.toString());
        });
    },
    getRegisType: function (thaistudent, start1, finish1) {
      api
        // .getRegisTypeAll(thaistudent)
        .getRegisTypeBetween(thaistudent, start1, finish1)
        .then(res => {
          // console.log("getRegisType==", res.data.data)
          this.items = res.data.data;
          // console.log(this.items);
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    },
    getCurrentPart10(studentid){
      api
        // .getCountPart10(studentid)
        // .then(res => {
        //   // console.log("getAnsPart10==", res.data.data[0].C_ROW);
        //   this.q7 = res.data.data[0].QN_11;
        //   // console.log("q7==", this.q7);
        // })
        .getAnsAllPart10(studentid)
        .then(res => {
          // console.log("res==",res,res.data.data.length)
          var count=0,rr=0;
          if (res.data.data.length==1) {
            if (res.data.data[0].QN_201 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_202 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_203 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_204 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_205 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_206 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_207 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_208 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_209 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_210 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_211 < 1) {
              rr++;
            } else {
              count++;
            }
             if (count==11){
               this.q7=1;
             }else{
               this.q7 =0;
             }

          }else{
            this.q7 =0;
          }
          //  console.log("e==",err,"c==",count)
        })
        .catch(err => {
          console.log("getCurrentStudent", err.toString());
          return 0;
        });
    },
  },
  mounted() {
  },
  created() {
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/logout");
    } else {
      // this.$router.push("/Dashboard");
    }
    this.std_id = this.$store.state.user.studentid;
    this.thai_student = this.$store.state.user.thaistudent;
    // this.thai_student =0
    this.levelid = this.$store.state.user.levelid;
    this.current_graduatestatus = this.$store.state.user.graduate_status;
    this.current_postpone = this.$store.state.user.postpone_status;
    api.onSetHeader();
    this.getCurrentPart10(this.std_id);
    this.actionUpdate = this.getCurrentStudent(this.std_id);
    // console.log("397q1 =",this.q1  );
    // console.log("398q4 =",this.q4  );
    // this.getRegisType(this.thai_student);
  }
};
</script>
<style>
</style>
